import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subject, distinctUntilChanged, switchMap, takeUntil } from 'rxjs';

import { DomService } from 'ish-core/utils/dom/dom.service';
import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsFacade } from '../facades/dot-cms.facade';
import { CustomDotCmsPageContainer } from '../models/container/custom-dot-cms-page-container.model';

@Directive({
  selector: '[dotCmsContainerEditWrapper]',
  exportAs: 'dotCmsContainerEditWrapper',
})
export class DotCmsContainerEditWrapperDirective implements OnInit, OnDestroy, OnChanges {
  @Input() container: string;
  @Input() uuid: string;
  private container$ = new ReplaySubject<string>(1);
  private destroy$ = new Subject<void>();

  constructor(private dotCmsFacade: DotCmsFacade, private elementRef: ElementRef, private domService: DomService) {}

  ngOnInit(): void {
    this.container$
      .pipe(
        takeUntil(this.destroy$),
        whenTruthy(),
        distinctUntilChanged(),
        switchMap(value => this.dotCmsFacade.getContainerByIdentifier$(value))
      )
      .subscribe(container => this.setContainerDotCmsEditAttributes(container));
  }

  ngOnChanges(): void {
    this.container$.next(this.container);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Todo: Fix code duplication
  private setContainerDotCmsEditAttributes(pageContainer: CustomDotCmsPageContainer) {
    const acceptTypes = pageContainer?.containerStructures.map(structure => structure.contentTypeVar).join(',');
    this.setDataAttribute('data-dot-object', 'container');
    this.setDataAttribute('data-dot-accept-types', acceptTypes);
    this.setDataAttribute('data-dot-inode', pageContainer.container?.inode);
    this.setDataAttribute('data-dot-identifier', pageContainer.container?.path || pageContainer.container?.identifier);
    this.setDataAttribute('data-dot-uuid', this.uuid);
    this.setDataAttribute('data-max-contentlets', `${pageContainer.container?.maxContentlets}`);
    this.setDataAttribute('data-dot-can-add', 'CONTENT,FORM,WIDGET');
    this.setDataAttribute('data-testid', 'dot-container');
  }

  //Todo: Fix code duplication
  setDataAttribute(key: string, value: string) {
    if (!!key && !!value) this.domService.setAttribute(this.elementRef.nativeElement, key, value);
  }
}
